import { render } from "./medecinSession.vue?vue&type=template&id=6a02424f&scoped=true"
import script from "./medecinSession.vue?vue&type=script&lang=js"
export * from "./medecinSession.vue?vue&type=script&lang=js"

import "./medecinSession.vue?vue&type=style&index=0&id=6a02424f&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a02424f"]])

export default __exports__